import React from 'react';

const Profile = () => {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-text mb-8">
          Mon Profil
        </h1>
        <div className="card p-8">
          <p className="text-gray-600">
            Gestion du profil en cours de développement
          </p>
        </div>
      </div>
    </div>
  );
};

export default Profile;









